import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsEmailRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsEmailRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { HelpCenterSettingsEmail, LazyHelpCenterSettingsEmail } from './ui/email/index.tsx';

export const helpCenterSettingsEmailRouteEntry: Route = createEntry(
	helpCenterSettingsEmailRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.email',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		// eslint-disable-next-line no-restricted-syntax
		component: HelpCenterSettingsEmail,
		forPaint: [LazyAtlassianNavigation, LazyHelpCenterSettingsEmail],
		resources: [...getServiceDeskSettingsResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
